import React, { useEffect, useMemo } from 'react'
import { hot } from 'react-hot-loader/root'
import { openActivityPopup } from '../../utils/openActivityPopup'
import RemoteApp from '../../utils/RemoteAppWrapper'

const addGlobalStyles = () => {
  const css = `
    html, body { overflow: auto }

    #contentTd { height: auto !important }

    #footer { display: none !important }

    .wb-tooltip { display: none !important }

    #mySidenasSingleEdit { display: none !important }
  `
  const head = document.head || document.getElementsByTagName('head')[0]
  const style = document.createElement('style')

  head.appendChild(style)

  style.id = 'workstreams-styles'

  style.appendChild(document.createTextNode(css))
}

const removeGlobalStyles = () => {
  document.getElementById('workstreams-styles').remove()
}

const WorkstreamsApp = ({
  externalData,
}) => {
  useEffect(() => {
    addGlobalStyles()

    return () => {
      removeGlobalStyles()
    }
  }, [])

  // RemoteAppWrapper mounts the remote again whenever this object changes.
  const data = useMemo(() => ({
    scope: 'WorkstreamsUI',
    module: './WorkstreamsApp',
    externalData: {
      ...externalData,
      analytics: {
        trackEvent: window.wb_track,
        // The remote adds the subLocation for the view it is showing.
        eventProperties: { location: 'WORKSTREAM_VIEWS_PAGE' },
      },
      onActivityClick: openActivityPopup,
      // WorkBoard's top bar; the remote adds its own page header to this.
      verticalGap: 65,
    },
  }), [externalData])

  return <RemoteApp data={data} />
}

export default hot(WorkstreamsApp);
